module.exports = __webpack_public_path__ + "static/media/kepka.917b0207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kepka.jpg
// module id = 209
// module chunks = 0